module.exports = __webpack_public_path__ + "static/media/pistol-poem1.8d0dd551.jpg";